import React from "react";
import AddressAutocomplete from "../shared/AddressAutocomplete";
import { estManquant } from "../../lib/champsManquants";

/**
 * Adresse pour le reçu fiscal (rue, code postal, ville), affichée APRÈS le
 * code sur les pages campagne et don : pré-remplie depuis la fiche,
 * modifiable, et chaque champ absent de la fiche est surligné.
 *
 * Props :
 *  - valeurs        : { address, postalCode, city }
 *  - onChange(champ, valeur) — champ ∈ address | postalCode | city
 *  - manquants      : ``missing_fields`` de recognize-donor (avec le jeton)
 *  - champClasse    : classes communes des champs (taille de texte de la page)
 *  - textes         : libellés traduits (page de don bilingue)
 */
const TEXTES = {
  titre: "Adresse pour votre reçu fiscal",
  rue: "Adresse (numéro et rue)",
  codePostal: "Code postal",
  ville: "Ville",
  aCompleter: "à compléter",
};

export default function AdresseRecu({ valeurs, onChange, manquants, champClasse = "", textes }) {
  const t = { ...TEXTES, ...(textes || {}) };
  const bord = (champ) => (estManquant(manquants, champ)
    ? "border-amber-300 bg-amber-50/40"
    : "border-stone-200 bg-white");
  const classe = (champ) => `w-full min-w-0 px-3 py-2.5 rounded-xl border focus:outline-none focus:ring-2 focus:ring-stone-900/10 ${bord(champ)} ${champClasse}`;
  const manque = ["address", "postal_code", "city"].some((c) => estManquant(manquants, c));
  return (
    <div className="mt-3" data-testid="adresse-recu">
      <p className="mb-1.5 text-[10px] uppercase tracking-[0.15em] text-stone-500">
        {t.titre}
        {manque && <span className="ml-1 normal-case tracking-normal text-amber-700">— {t.aCompleter}</span>}
      </p>
      <div className="space-y-2">
        <AddressAutocomplete
          value={valeurs.address}
          onChange={(v) => onChange("address", v)}
          onSelect={({ address, postalCode, city }) => {
            onChange("address", address);
            onChange("postalCode", postalCode);
            onChange("city", city);
          }}
          placeholder={t.rue}
          testid="adresse-recu-rue"
          inputClassName={classe("address")}
        />
        <div className="grid grid-cols-2 gap-2">
          <input value={valeurs.postalCode} onChange={(e) => onChange("postalCode", e.target.value)}
            placeholder={t.codePostal} inputMode="numeric" autoComplete="postal-code"
            data-testid="adresse-recu-cp" className={classe("postal_code")} />
          <input value={valeurs.city} onChange={(e) => onChange("city", e.target.value)}
            placeholder={t.ville} autoComplete="address-level2"
            data-testid="adresse-recu-ville" className={classe("city")} />
        </div>
      </div>
    </div>
  );
}
